// internal
import { ResponseMeta } from '@app/typings/services/service.d';
import {
  ProjectData,
  ProjectWithIdData,
  FormCreateProject,
  roleProjectData,
  DeviceData,
} from '@app/typings/services/project';

export const KEY_PROJECT_FETCH = 'KEY_PROJECT_FETCH';
export interface FetchData {
  type: typeof KEY_PROJECT_FETCH;
  payload: {
    brand: string;
    name?: string;
    offset?: number;
    limit?: number;
  };
}

export const KEY_PROJECT_FETCH_WITHID = 'KEY_PROJECT_FETCH_WITHID';
export interface FetchProjectWithId {
  type: typeof KEY_PROJECT_FETCH_WITHID;
  payload: string;
}

export const KEY_PROJECT_SET_DATA = 'KEY_PROJECT_SET_DATA';
export interface SetData {
  type: typeof KEY_PROJECT_SET_DATA;
  payload: {
    meta: ResponseMeta;
    data: ProjectData[];
  };
}

export const KEY_PROJECT_SET_WITHID = 'KEY_PROJECT_SET_WITHID';
export interface SetProjectWithIdData {
  type: typeof KEY_PROJECT_SET_WITHID;
  payload: ProjectWithIdData;
}

export const KEY_PROJECT_SELECT_ID = 'KEY_PROJECT_SELECT_ID';
export interface SelectID {
  type: typeof KEY_PROJECT_SELECT_ID;
  payload: {
    id: string;
    name: string;
    isSetting?: boolean;
  };
}

export const KEY_PROJECT_CLEAR_SELECT = 'KEY_PROJECT_CLEAR_SELECT';
export interface ClearSelectID {
  type: typeof KEY_PROJECT_CLEAR_SELECT;
}

export const KEY_PROJECT_CREATE = 'KEY_PROJECT_CREATE';
export interface CreateProject {
  type: typeof KEY_PROJECT_CREATE;
  payload: {
    brandId: string;
    data: FormCreateProject;
  };
}

export const KEY_PROJECT_UPDATE = 'KEY_PROJECT_UPDATE';
export interface UpdateProject {
  type: typeof KEY_PROJECT_UPDATE;
  payload: {
    data: FormCreateProject;
    isSameName: boolean;
    isSetting?: boolean;
  };
}

export const KEY_PROJECT_DELETE = 'KEY_PROJECT_DELETE';
export interface DeleteProject {
  type: typeof KEY_PROJECT_DELETE;
  payload: {
    brand: string;
    projects: string[];
  };
}

export const KEY_PROJECT_ROLE_WITHID = 'KEY_PROJECT_ROLE_WITHID';
export interface RoleProjectWithId {
  type: typeof KEY_PROJECT_ROLE_WITHID;
  payload: {
    projectId: string;
    roleId: string;
  };
}

export const KEY_PROJECT_SET_CURRENTROLE = 'KEY_PROJECT_SET_CURRENTROLE';
export interface SetCurrentRoleProject {
  type: typeof KEY_PROJECT_SET_CURRENTROLE;
  payload: roleProjectData;
}

export const KEY_PROJECT_CLEAR_CURRENTROLE = 'KEY_PROJECT_CLEAR_CURRENTROLE';
export interface ClearCurrentRoleProject {
  type: typeof KEY_PROJECT_CLEAR_CURRENTROLE;
}

export const KEY_PROJECT_LISTROLES = 'KEY_PROJECT_LISTROLES';
export interface ListRolesProject {
  type: typeof KEY_PROJECT_LISTROLES;
  payload: {
    offset: number;
    limit: number;
    brief: boolean;
  };
}

export const KEY_PROJECT_SET_LISTROLES = 'KEY_PROJECT_SET_LISTROLES';
export interface SetListRolesProject {
  type: typeof KEY_PROJECT_SET_LISTROLES;
  payload: {
    data: roleProjectData[];
    meta: ResponseMeta;
  };
}

export const KEY_PROJECT_CREATE_ROLE = 'KEY_PROJECT_CREATE_ROLE';
export interface CreateRoleProject {
  type: typeof KEY_PROJECT_CREATE_ROLE;
  payload: {
    roleName: string;
    permission: string[];
  };
}

export const KEY_PROJECT_UPDATE_ROLE = 'KEY_PROJECT_UPDATE_ROLE';
export interface UpdateRoleProject {
  type: typeof KEY_PROJECT_UPDATE_ROLE;
  payload: {
    roleName: string;
    permission: string[];
  };
}

export const KEY_PROJECT_DELETE_ROLES = 'KEY_PROJECT_DELETE_ROLES';
export interface DeleteRolesProject {
  type: typeof KEY_PROJECT_DELETE_ROLES;
  payload: {
    roleId: string[];
  };
}

export const KEY_PROJECT_SET_DEVICES = 'KEY_PROJECT_SET_DEVICES';
export interface SetDevicesInProject {
  type: typeof KEY_PROJECT_SET_DEVICES;
  payload: DeviceData[];
}

export const KEY_PROJECT_CLEAR_CURRENTID = 'KEY_PROJECT_CLEAR_CURRENTID';
export interface ProjectClearCurrentId {
  type: typeof KEY_PROJECT_CLEAR_CURRENTID;
}

export const KEY_PROJECT_UPLOAD_PICTURE = 'KEY_PROJECT_UPLOAD_PICTURE';
export interface ProjectUploadPicture {
  type: typeof KEY_PROJECT_UPLOAD_PICTURE;
  payload: {
    projectId: string;
    file: any;
  };
}

export const KEY_PROJECT_CLEAR_LOADING = 'KEY_PROJECT_CLEAR_LOADING';
export interface ClearLoading {
  type: typeof KEY_PROJECT_CLEAR_LOADING;
}
export const KEY_PROJECT_SET_LOADING = 'KEY_PROJECT_SET_LOADING';
export interface SetLoading {
  type: typeof KEY_PROJECT_SET_LOADING;
}

export type ProjectType =
  | FetchData
  | FetchProjectWithId
  | SetData
  | ClearLoading
  | SetLoading
  | SetProjectWithIdData
  | SelectID
  | ClearSelectID
  | CreateProject
  | UpdateProject
  | DeleteProject
  | RoleProjectWithId
  | SetCurrentRoleProject
  | ClearCurrentRoleProject
  | ListRolesProject
  | SetListRolesProject
  | CreateRoleProject
  | UpdateRoleProject
  | DeleteRolesProject
  | ManageUserInProject
  | ManageUsersInProject
  | DeleteUserInProject
  | CheckboxUserInProject
  | FetchAllLockersInProject
  | SetAllLockersInProject
  | FetchAllDoorsInProject
  | SetAllDoorsInProject
  | FetchDevicesInProject
  | SetDevicesInProject
  | GroupWithId
  | SetCurrentGroup
  | ListGroupsProject
  | ListGroupsProjectEndUser
  | SetDataGroupsProject
  | CreateGroupProject
  | UpdateGroupProject
  | ClearGroupProject
  | DeleteGroupProject
  | ProjectClearCurrentId
  | ProjectListCardGroup
  | ProjectSetCardGroup
  | ProjectUploadPicture
  | SetFilterGroup;
